export const EVENT_LOGS = {
    DATA_FETCHED: 'EVENT_LOGS.DATA_FETCHED',
};
